// extracted by mini-css-extract-plugin
export default {"container":"S01_Intro_container__alpaw","limiter":"S01_Intro_limiter__mZQxk","ball":"S01_Intro_ball__8nQGT","block":"S01_Intro_block__TBP9F","accent":"S01_Intro_accent__Vuird"};